// extracted by mini-css-extract-plugin
export default {"page-container":"errorpage_page-container__4-tQb"};